import React from "react";
import ScreenLayout from "../../layout/ScreenLayout/ScreenLayout";
import { ActiveBitrixChatBotContainer } from "../../components/ActiveBitrixChatBotContainer/ActiveBitrixChatBotContainer";

const ActiveBitrixChatBotScreen = () => {
  return (
    <ScreenLayout>
      <ActiveBitrixChatBotContainer />
    </ScreenLayout>
  );
};

export default ActiveBitrixChatBotScreen;
